import { Component, OnInit, PLATFORM_ID, Inject } from '@angular/core';
import { Title, Meta } from '@angular/platform-browser';
import { isPlatformBrowser } from '@angular/common';
import { LinkService } from '../../_services/langhfre.service';
import { LoadScriptService } from 'src/app/_services/load-script.service';

@Component({
  selector: 'app-home',
  templateUrl: './home.component.html',
  styleUrls: ['./home.component.scss']
})
export class HomeComponent implements OnInit {

  showLanguages: boolean = false;

  constructor(
    private titleService: Title,
    private metaTagService: Meta,
    @Inject(PLATFORM_ID) private platformId: Object,
    private LinkService: LinkService,
    public loadScript: LoadScriptService
  ) {
  }

  ngOnInit() {
    this.titleService.setTitle('Trinka: 學術寫作AI文法檢查工具');
    this.metaTagService.updateTag({ name: 'description', content: '用 AI 學術寫作幫手提升你的文筆和文法！Trinka 透過 AI 校訂與校稿，讓你的表達更清晰、簡潔、有力。現在免費試用！' });
    this.metaTagService.updateTag({ name: 'keywords', content: '用於學術和技術寫作的文法檢查工具，高級文法校正，學術寫作助手，技術寫作助手，高級文法檢查，自動化文法檢查工具，自動化文法校正，學術寫作人工智慧工具。' });
    this.metaTagService.updateTag({ property: 'og:title', content: 'Trinka: 學術寫作AI文法檢查工具' });
    this.metaTagService.updateTag({ property: 'og:description', content: '用 AI 學術寫作幫手提升你的文筆和文法！Trinka 透過 AI 校訂與校稿，讓你的表達更清晰、簡潔、有力。現在免費試用！' });
    this.metaTagService.updateTag({ property: 'og:url', content: 'https://www.trinka.ai/tw/' });
    this.metaTagService.updateTag({ property: 'og:type', content: 'website' });
    this.metaTagService.updateTag({ name: 'language', content: 'zh-tw' });
    this.LinkService.addTag({ rel: 'canonical', href: 'https://www.trinka.ai/tw/' });
    this.LinkService.addTag({ rel: 'alternate', hreflang: 'x-default', href: 'https://www.trinka.ai' });
    this.LinkService.addTag({ rel: 'alternate', hreflang: 'en-us', href: 'https://www.trinka.ai' });
    this.LinkService.addTag({ rel: 'alternate', hreflang: 'ja-jp', href: 'https://www.trinka.ai/jp/' });
    this.LinkService.addTag({ rel: 'alternate', hreflang: 'zh-tw', href: 'https://www.trinka.ai/tw/' });
    this.LinkService.addTag({ rel: 'alternate', hreflang: 'zh-cn', href: 'https://trinka.enago.cn' });
    this.LinkService.addTag({ rel: 'alternate', hreflang: 'ko-kr', href: 'https://www.trinka.ai/kr/' });
    this.LinkService.addTag({ rel: 'alternate', hreflang: 'es-es', href: 'https://www.trinka.ai/es/' });
    this.LinkService.addTag({ rel: 'alternate', hreflang: 'pt-pt', href: 'https://www.trinka.ai/pt/' });
  }
  // ngOnDestroy() {
  //   if (isPlatformBrowser(this.platformId)) {
  //     document.getElementById('main_header').classList.remove('homepageHeader');
  //   }
  // }

  tools = [
    { link: '/grammar-checker', imgSrc: '/assets/images/menu-icons/grammar-checker.svg', label: '文法檢查', alt: '文法檢查' },
    { link: '/paraphrasing-tool', imgSrc: '/assets/images/menu-icons/pharaphraser.svg', label: '文章改寫', alt: '文章改寫' },
    { link: '/features/plagiarism-check', imgSrc: '/assets/images/menu-icons/plagiarism.svg', label: '抄襲檢測', alt: '抄襲檢測' },
    { link: '/features/ai-studio/ai-writing-tools', imgSrc: '/assets/images/menu-icons/ai-apps.svg', label: 'AI Studio', alt: 'AI Studio icon' }
  ];

  iconsList = [
    { src: "/assets/images/list-icons/google-gmail.svg", alt: "gmail", width: 27, height: 21 },
    { src: "/assets/images/list-icons/chrome.svg", alt: "chrome", width: 28, height: 27 },
    { src: "/assets/images/list-icons/linkedin.svg", alt: "linkedin", width: 27, height: 27 },
    { src: "/assets/images/list-icons/bing.svg", alt: "bing", width: 18, height: 28 },
    { src: "/assets/images/list-icons/apple.svg", alt: "apple", width: 32, height: 31 },
    { src: "/assets/images/list-icons/facebook.svg", alt: "facebook", width: 29, height: 29 },
    { src: "/assets/images/list-icons/office.svg", alt: "office", width: 21, height: 25 },
    { src: "/assets/images/list-icons/googledocs.svg", alt: "googledocs", width: 27, height: 27 },
    { src: "/assets/images/list-icons/medium.svg", alt: "medium", width: 39, height: 6 },
    { src: "/assets/images/list-icons/powerpoint.svg", alt: "powerpoint", width: 32, height: 32 },
    { src: "/assets/images/list-icons/asana.svg", alt: "asana", width: 39, height: 8 },
    { src: "/assets/images/list-icons/word.svg", alt: "word", width: 29, height: 30 },
    { src: "/assets/images/list-icons/notion.svg", alt: "notion", width: 39, height: 14 },
    { src: "/assets/images/list-icons/firefox.svg", alt: "firefox", width: 27, height: 28 },
    { src: "/assets/images/list-icons/twitter.svg", alt: "twitter", width: 27, height: 28 },
    { src: "/assets/images/list-icons/outlook.svg", alt: "outlook", width: 30, height: 30 },
    { src: "/assets/images/list-icons/quora.svg", alt: "quora", width: 33, height: 9 },
    { src: "/assets/images/list-icons/bi_substack.svg", alt: "bi_substack", width: 20, height: 20 }
  ];

  trackByFn(index: number, item: any): string | number {
    return item.id || index;
  }

}
